"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = Card;
exports.CardHeader = CardHeader;
exports.CardTitle = CardTitle;
exports.CardDescription = CardDescription;
exports.CardBody = CardBody;
exports.CardFooter = CardFooter;
const jsx_runtime_1 = require("react/jsx-runtime");
const utils_1 = require("../utils");
// The signature surface: 24px radius (rounded-2xl), neutral-100 border, surface bg.
// Padding matches --aiq-space-card desktop / --aiq-space-card-mobile mobile.
//   default     — surface + border + shadow-xs (resting)
//   flat        — surface + border, no shadow
//   interactive — adds hover lift to shadow-md, intended for clickable cards
const variantStyles = {
    default: 'bg-surface border border-neutral-100 shadow-xs',
    flat: 'bg-surface border border-neutral-100',
    interactive: 'bg-surface border border-neutral-100 shadow-xs transition-shadow duration-150 hover:shadow-md hover:-translate-y-px cursor-pointer'
};
function Card(_a) {
    var { variant = 'default', className, children } = _a, props = __rest(_a, ["variant", "className", "children"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, props, { className: (0, utils_1.cn)('rounded-2xl p-3 sm:p-6', variantStyles[variant], className), children: children })));
}
function CardHeader(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, props, { className: (0, utils_1.cn)('mb-4 flex items-start justify-between gap-3', className), children: children })));
}
function CardTitle(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return ((0, jsx_runtime_1.jsx)("h3", Object.assign({}, props, { className: (0, utils_1.cn)('text-2xl font-bold leading-tight text-neutral-900', className), children: children })));
}
function CardDescription(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return ((0, jsx_runtime_1.jsx)("p", Object.assign({}, props, { className: (0, utils_1.cn)('text-xs text-neutral-500', className), children: children })));
}
function CardBody(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, props, { className: (0, utils_1.cn)(className), children: children })));
}
function CardFooter(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({}, props, { className: (0, utils_1.cn)('mt-4 flex items-center justify-end gap-2', className), children: children })));
}
